import { EventType } from "./models";

/*
* Зеркало client-DTO бэка (services/organizationbranches/menu/v1 и stats/menu/v1). Генератора
* нет: правишь DTO — правь здесь в тот же заход, компилятор расхождения не увидит.
* */

export interface LocalizedString {
    [locale: string]: string | undefined;
}

export enum CompanyCardType {
    russianOOO = "RussianOOOCard",
    russianIP = "RussianIPCard",
}

export interface RussianOOOCardRest {
    type: CompanyCardType.russianOOO;
    shortTitle: LocalizedString;
    fullTitle: LocalizedString;
    inn: string;
    kpp: string;
    ogrn: string;
    legalAddress: LocalizedString;
}

export interface RussianIPCardRest {
    type: CompanyCardType.russianIP;
    shortTitle: LocalizedString;
    fullTitle: LocalizedString;
    inn: string;
    ogrnip: string;
    legalAddress: LocalizedString;
}

export type CompanyCardRest = RussianOOOCardRest | RussianIPCardRest;

export interface CloudPaymentsCheckoutDetailsRest {
    type: "CloudPaymentsCheckout";
    publicId: string;
}

export interface PaymentProvidersDetailsRest {
    CloudPaymentsCheckout: CloudPaymentsCheckoutDetailsRest | null;
}

/*
* Меню шлёт только события-конверсии, поэтому value описано необязательным, а не отдельным
* подтипом: разбирать на бэке union из-за одного поля дороже, чем описать его здесь.
*
* Филиал и организацию бэк проставляет сам по menuId — их тут нет намеренно.
* */
export interface NewEventRest {
    type: EventType;
    name: string;
    menuId: number | null;
    clientSessionId: string | null;
    orderId: number | null;
    metainfo: string | null;
    orderSessionId: string | null;
    value?: number;
}
